
export default function Registry() {
  return (
    <section id="registry" className="py-16 sm:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-12">
          <div className="w-16 h-px bg-gray-800 mx-auto mb-6"></div>
          <h2 className="font-serif text-4xl sm:text-5xl md:text-6xl text-gray-900 mb-6">Registry Information</h2>
          <p className="text-gray-600 text-sm sm:text-base font-light tracking-wide max-w-2xl mx-auto leading-relaxed px-4">
            Your presence at our wedding is the greatest gift we could ask for. However, if you wish to honor us with a gift, we have registered at the following stores for your convenience.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-6 sm:gap-8 max-w-4xl mx-auto mt-12 sm:mt-16">
          {/* Amazon */}
          <a
            href="https://www.amazon.com/wedding/guest-view/972AEF1PKEYK"
            target="_blank"
            rel="noopener noreferrer"
            className="group bg-white p-8 sm:p-12 flex flex-col items-center justify-center hover:shadow-lg transition-all duration-300 cursor-pointer"
          >
            <div className="w-24 h-24 sm:w-32 sm:h-32 flex items-center justify-center mb-6">
              <img
                src="https://public.readdy.ai/ai/img_res/3f7b908c9e8aa0439db314c35ebd69ba.jpg"
                alt="Amazon Registry"
                className="w-full h-full object-contain group-hover:scale-105 transition-transform duration-300"
              />
            </div>
            <span className="text-gray-800 text-sm font-light tracking-wide underline">Visit Registry</span>
          </a>

          {/* Target */}
          <a
            href="https://www.target.com/gift-registry/gift/EvanplusMaryequalsForever"
            target="_blank"
            rel="noopener noreferrer"
            className="group bg-white p-8 sm:p-12 flex flex-col items-center justify-center hover:shadow-lg transition-all duration-300 cursor-pointer"
          >
            <div className="w-24 h-24 sm:w-32 sm:h-32 flex items-center justify-center mb-6">
              <img
                src="https://readdy.ai/api/search-image?query=target%20store%20logo%20official%20brand%20red%20bullseye%20icon%20simple%20clean%20modern%20design%20on%20white%20background%20high%20quality%20professional&width=300&height=300&seq=target001&orientation=squarish"
                alt="Target Registry"
                className="w-full h-full object-contain group-hover:scale-105 transition-transform duration-300"
              />
            </div>
            <span className="text-gray-800 text-sm font-light tracking-wide underline">Visit Registry</span>
          </a>

          {/* Bed Bath & Beyond / Crate & Barrel */}
          <a
            href="https://www.talkable.com/x/NpTuPs"
            target="_blank"
            rel="noopener noreferrer"
            className="group bg-white p-8 sm:p-12 flex flex-col items-center justify-center hover:shadow-lg transition-all duration-300 cursor-pointer sm:col-span-2 md:col-span-1"
          >
            <div className="w-24 h-24 sm:w-32 sm:h-32 flex items-center justify-center mb-6">
              <img
                src="https://readdy.ai/api/search-image?query=crate%20and%20barrel%20logo%20official%20brand%20identity%20elegant%20home%20goods%20store%20simple%20clean%20modern%20design%20on%20white%20background%20high%20quality%20professional&width=300&height=300&seq=cratebarrel001&orientation=squarish"
                alt="Crate & Barrel Registry"
                className="w-full h-full object-contain group-hover:scale-105 transition-transform duration-300"
              />
            </div>
            <span className="text-gray-800 text-sm font-light tracking-wide underline">Visit Registry</span>
          </a>
        </div>

        <div className="text-center mt-12">
          <div className="inline-block">
            <i className="ri-gift-line text-4xl text-gray-800"></i>
          </div>
        </div>
      </div>
    </section>
  );
}
